import { z } from "zod";

export const taxesSchema = z.object({
  chargeTaxes: z.boolean(),
  taxCalculationStrategy: z.string(),
  displayGrossPrices: z.boolean(),
  pricesEnteredWithTax: z.boolean(),
});
